import type { AssetPlan } from '#/graphql/types';
import { getBaseColumns } from '#/common/utils/baseColumns';
import FieldDefs from '#/types/FieldDefs';
import { assetPlanStatusItems } from './constants';

const fields = {
  ...getBaseColumns(),
  id: {
    dataField: 'id',
    label: 'ID',
    editorOptions: { readOnly: true },
  },
  displayNumber: {
    dataField: 'displayNumber',
    label: 'Number',
    editorOptions: {
      readOnly: true,
      placeholder: 'Auto generated',
    },
  },
  name: {
    dataField: 'name',
    label: 'Name',
    editorType: 'TextBox',
    isRequired: true,
  },
  status: {
    dataField: 'status',
    label: 'Status',
    editorType: 'SelectBox',
    editorOptions: {
      items: assetPlanStatusItems,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  startYear: {
    dataField: 'startYear',
    label: 'Start Year',
    editorType: 'NumberBox',
    editorOptions: {
      format: '#',
      showSpinButtons: true,
    },
  },
  endYear: {
    dataField: 'endYear',
    label: 'End Year',
    editorType: 'NumberBox',
    editorOptions: {
      format: '#',
      showSpinButtons: true,
    },
  },
  notes: {
    dataField: 'notes',
    label: 'Notes',
    editorType: 'TextArea',
    editorOptions: {
      autoResizeEnabled: true,
      minHeight: 120,
      placeholder: 'No notes',
    },
  },
} satisfies FieldDefs<AssetPlan>;

export default fields;
